import React, { Component } from 'react'
import './PickingComponent.scss'
import { browserHistory } from 'react-router'
import HeaderModal from '../../HeaderComponent/HeaderModal/HeaderModal'
import {
  AppContainer,
  AppContent,
  LogoContainer,
  Logo,
  PrimaryButton,
  ModalLink
} from './PickingStyles'
class PickingComponent extends Component {
  constructor () {
    super()
    this.state = {
      openInfo: false,
      openGlossary: false,
      openHelp: false
    }
  }

  move (link) {
    browserHistory.push(link)
  }

  handleChangeModal (name) {
    let change = { ...this.state }
    change[name] = !change[name]
    this.setState(
      change
    )
  }

  render () {
    const { openInfo, openGlossary, openHelp } = this.state
    return (
      <AppContainer>
        <AppContent>
          <LogoContainer style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Logo src='proton.png' />
          </LogoContainer>
          <p>
            Welcome to PROTON Wizard's radicalization and recruitment to terrorism simulations, built
            using Agent-Based modelling and extensive empirical data derived from project PROTON. The
            simulated environment represents a prototypical borough of a major European city,.  Users
            are able to tailor the environment to match the characteristics of their own city, examine
            base rates of radicalization and recruitment to terrorism, and examine how different levels
            of implementation of key experimental conditions affect radicalization and recruitment to
            terrorism, as well as other outcomes such as perceptions of integration, legitimacy, and
            subjective deprivation.
          </p>
          <br />
          <p>
            To access the User Manual <ModalLink onClick={() => this.handleChangeModal('openHelp')}>click here</ModalLink>.
          </p>
          <p>
            For more information on project PROTON <ModalLink onClick={() => this.handleChangeModal('openInfo')}>click here</ModalLink>.
          </p>
          <PrimaryButton fluid onClick={() => this.move('/selectType')}>PROTON Wizard</PrimaryButton>
        </AppContent>
        <HeaderModal
                header='Info'
                open={openInfo}
                handleChangeModal={() => this.handleChangeModal('openInfo')}
              >
          <div>
                  A brief introduction to agent-based models and their use in project PROTON What is an ABM?
          </div>
          <ul>
            <li>
                    An agent-based model (ABM) is a computer simulation that models relations among agents
                    (e.g. individuals) and their behaviour, thus providing a simplified representation of the social
                    reality
            </li>
          </ul>
          <div>Why is it useful?</div>
          <ul>
            <li>
                    ABMs are increasingly used to simulate the impact of specific policy interventions
            </li>
            <li>
                    AMBs offer many advantages:
              <ul>
                <li>
                        They enable to test policies without harming individuals’ rights and freedoms
                </li>
                <li>
                        They enable to conduct virtual experiments to assess the impact of different
                        policies before actual deployment
                </li>
                <li>
                        They are often more cost-efficient and fast than field experiments or pilot experimentations
                </li>
                <li>
                        They enable to test the long-term effect of specific policies, e.g. the impact in 20 or 30 years
                </li>
              </ul>
            </li>
            <li>
                    The development and use of ABMs, however, includes a few requirements
              <ul>
                <li>
                        Proper simulation design and validation require specific domain expertise
                </li>
                <li>
                        Simulations are just as good as the input data, i.e. simulations must be realistic to provide
                        realistic results
                </li>
                <li>
                        The development of ABMs requires coding, statistical, and computational capacities
                </li>
              </ul>
            </li>
          </ul>
          <div>
                  The ABMs in Project PROTON • The ABMs in Project PROTON comprise a set of different simulations
                  modelling the factors leading individuals to join organised crime or terrorist networks
          </div>
        </HeaderModal>
        <HeaderModal
                open={openGlossary}
                header='Glossary'
                handleChangeModal={() => this.handleChangeModal('openGlossary')}
              >
          <div>
            <b>Number of OC members:</b> This setting determines the number of organised crime members at the
                  start of the simulation. The medium level, based on PROTON's empirical analysis of a Southern
                  European city, is 30 members per 10,000 inhabitants.
          </div>
          <br />
          <div>
            <b>Crime rate:</b> This setting determines the overall crime rate at the start of the simulation,
                  including any type of crime and also non-reported crime. The medium level, based on PROTON's
                  empirical analysis of a Southern European city, is approximately 2,400 crimes per 10,000
                  inhabitants per year.
          </div>
          <br />
          <div>
            <b>Employment rate:</b> This setting determines the unemployment rate in the simulation.
                  The medium level, based on PROTON's empirical analysis of a Southern European city, corresponds
                  to an unemployment rate of approximately 50% for the population aged 15-65.
          </div>
          <br />
          <div>
            <b>Law enforcement intervention rate:</b> This setting determines the rate of imprisonment
                  penalties in the simulation. The medium level, based on PROTON's empirical analysis of a Southern
                  European city, corresponds to an imprisonment rate of approximately 26 individuals per 10,000
                  inhabitants.
          </div>
          <br />
          <div>
            <b>Punishment length:</b> This setting determines the length of imprisonment periods for
                  individuals sanctioned by the law enforcement system. The medium level, based on PROTON's
                  empirical analysis of a Southern European city, corresponds to a society where nearly half
                  of the convictions imposing imprisonment range between 3 months and 1 year.
          </div>
        </HeaderModal>
        <HeaderModal
                open={openHelp}
                header='Help'
                handleChangeModal={() => this.handleChangeModal('openHelp')}
                >
          <div>
                  How can PROTON simulation settings be modified in the wizard? The PROTON Wizard on organised
                  crime allows to choose the following options:
            <ul>
              <li>
                      Select between two possible environments: a society resembling a Southern European city
                      and one simulating a Northern European city
              </li>
              <li>
                      For each environment, select among four possible policy scenarios (presented above)
              </li>
              <li>
                      For each combination of environment and policy scenario, users are able to choose
                      low/medium/high levels of:
                <ul>
                  <li>
                          Number of organised crime members
                  </li>
                  <li>
                          Crime Rate
                  </li>
                  <li>
                          Unemployment Rate
                  </li>
                  <li>
                          Law Enforcement Intervention Rate
                  </li>
                  <li>
                          Punishment Length
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </HeaderModal>
      </AppContainer>
    )
  }
}

export default PickingComponent



// WEBPACK FOOTER //
// ./src/components/PickingComponent/components/PickingComponent.js